import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeDA from '@angular/common/locales/da';
import { AppComponent } from './app.component';
//MODULES
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';

import { AppRoutes } from './app-routing.module';
import { DynamicFormModule } from './dynamic-form/dynamic-form.module';
import { DeviceDetectorService } from 'ngx-device-detector';
registerLocaleData(localeDA);

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    CoreModule,
    AppRoutes,
    SharedModule,
    DynamicFormModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'da' },
    DeviceDetectorService 
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
